module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-1-1c77a829cc272c5324f908cc3cf86eb2.webp";